import { useCallback } from "react";
import { useUserModuleDispatch, USER_MODULE_ACTION } from "..";
import useGtagEvents from "../../gtag/hooks/use-gtag-events";

export default function useRestart() {
    const dispatch = useUserModuleDispatch();

    const { sendRestartGame } = useGtagEvents();

    return useCallback(() => {
        sendRestartGame();
        dispatch({
            type: USER_MODULE_ACTION.RESET_TASKS
        });

    }, [dispatch, sendRestartGame]);
}
